import React from 'react';
import "./_skeleton.scss";

export default function SkeletonText({component = "div"}) {
    return React.createElement(component, {className: "skeleton skeleton-text"}, [<>&nbsp;</>])
};
